import { render, staticRenderFns } from "./ProductDataAnalysisVisualizationView.vue?vue&type=template&id=a8218c76"
import script from "./ProductDataAnalysisVisualizationView.vue?vue&type=script&lang=js"
export * from "./ProductDataAnalysisVisualizationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports